/**
 * Функции компании — узлы на образующей окружности тора, через 2π/N.
 *
 * Порядок не алфавитный и не случайный: кольцо читается как цикл бизнеса.
 * Маркетинг → бренд → дизайн → контент → PR → продажи → продукт →
 * разработка → производство → автоматизация → эффективность → порядок →
 * контроль → решения → исполнение → финансы → бухгалтерия → HR → навыки →
 * безопасность → юр. функция — и снова маркетинг. Тор замыкает круг, поэтому последняя функция стоит
 * рядом с первой не по недосмотру, а по смыслу.
 */
export const BUSINESS_FUNCTIONS = {
  ru: [
    'Маркетинг', 'Бренд', 'Дизайн', 'Контент', 'PR', 'Продажи', 'Продукт',
    'Разработка', 'Производство', 'Автоматизация', 'Эффективность', 'Порядок',
    'Контроль', 'Решения', 'Исполнение', 'Финансы', 'Бухгалтерия', 'HR',
    'Навыки', 'Безопасность', 'Юр. функция',
  ],
  en: [
    'Marketing', 'Brand', 'Design', 'Content', 'PR', 'Sales', 'Product',
    'Engineering', 'Production', 'Automation', 'Efficiency', 'Order',
    'Control', 'Decisions', 'Execution', 'Finance', 'Accounting', 'HR',
    'Skills', 'Security', 'Legal',
  ],
} as const
